"use client"

import React from 'react'
import BaseFormProvider from "../../../../../shared/components/forms/base-form-provider"
import { homeWithHomeOwnerFormSchema } from "../../../schema/home-with-home-owner.schema"
import { HomeWithHomeOwnerFormType } from "../../../schema/home-with-home-owner.schema"
import { SubmitHandler } from "react-hook-form"

type CreateHomeWithOwnerFormProviderProps = {
    children: React.ReactNode
    onSubmit?: SubmitHandler<HomeWithHomeOwnerFormType>
}

/**
 * This component is used to provide the form schema for Home and Home Owner.
 * @param children - The form components to be rendered.
 * @param onSubmit - Optional submit handler. If not provided, uses empty function.
 * @returns The form provider component.
 */
function CreateHomeWithOwnerFormProvider({ children, onSubmit }: CreateHomeWithOwnerFormProviderProps) {

    return (
        <BaseFormProvider
            schema={homeWithHomeOwnerFormSchema}
            onSubmit={onSubmit || (() => {})}
            formOptions={{
                mode: "onChange",
            }}
        >
            {children}
        </BaseFormProvider>
    )
}

export default CreateHomeWithOwnerFormProvider
